import(/* webpackMode: "eager", webpackExports: ["Top"] */ "/codebuild/output/src1279907499/src/components/top.tsx");
